import { isSSR } from "src/utils/ssr";

export const doRedirectToThankYouPage = (
  brochureThankYouPageURL: string,
  openInNewPage: boolean
) => {
  const isServer = isSSR();
  if (isServer || !brochureThankYouPageURL) return;

  if (openInNewPage) {
    // console.log("redirecting to new tab:", brochureThankYouPageURL);
    // NOTE: window.open() doesn't work on iOS Safari. It fails silently in production
    // while it works locally when you try to observe it (Safari debugger attached to Safari on iPad)
    // window.open(brochureThankYouPageURL, "_blank");
    window.location.href = brochureThankYouPageURL;
  } else {
    // console.log("redirecting to same tab:", brochureThankYouPageURL);
    window.location.href = brochureThankYouPageURL;
  }
};

export const buildBrochureThankYouPageURL = (
  thankYouPageURL: string,
  brochureCode: string,
  printed: boolean
): string =>
  `${thankYouPageURL}?brochure=${encodeURIComponent(
    brochureCode
  )}&printed=${printed}`;
